<template>
  <v-app>
    <v-system-bar heigth="32" app color="secondary"
      ><v-icon>mdi-database</v-icon>
      <!-- Only show after the size of the cache has been established, ie after first read cycle  -->
      <div v-if="!!cacheFullSize" class="text-overline">
        {{
          isSynced ? cacheFullSize : cacheCurrentSize + ' of ' + cacheFullSize
        }}
      </div>
      <v-spacer></v-spacer>
      <v-progress-circular
        v-if="!isSynced"
        :value="40"
        :size="12"
        :width="2"
        indeterminate
      ></v-progress-circular>
    </v-system-bar>

    <v-navigation-drawer
      app
      disable-resize-watcher
      v-model="drawer"
      right
      clipped
    >
      <!-- TODO separate the login to separate sign-in/profile entries, not in menu array -->
      <v-list dense nav>
        <v-list-item v-for="item in menu" :key="item.title" link :to="item.to">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.title }}
            </v-list-item-title></v-list-item-content
          >
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app dark clipped-right color="primary">
      <!-- div used to remove truncation of title text, unclear why it works -->
      <!-- display: block -->
      <v-img
        contain
        max-height="48px"
        max-width="72px"
        src="wob-light.png"
      ></v-img>

      <v-app-bar-title>
        <!-- display: block -->
        <!-- WoB Explorer
        <v-icon dense right small color="secondary">mdi-flask-outline</v-icon>
        -->
      </v-app-bar-title>

      <v-spacer></v-spacer>

      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        v-if="$vuetify.breakpoint.xs"
      ></v-app-bar-nav-icon>

      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-btn text to="/search">
          <v-icon color="secondary" left>mdi-magnify</v-icon>Search
        </v-btn>

        <v-btn text to="/map">
          <v-icon color="secondary" left>mdi-map-outline</v-icon>Map
        </v-btn>

        <v-menu top :offset-y="true">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">
              <v-icon color="secondary" left>{{
                $wob.client.isAuthenticated
                  ? 'mdi-account-details'
                  : 'mdi-login'
              }}</v-icon
              >{{ $wob.client.isAuthenticated ? 'Profile' : 'Sign In' }}
            </v-btn>
          </template>
          <!-- display: block -->
          <v-card>
            <v-toolbar color="lime darken-2" dark>
              <v-toolbar-title>Profile</v-toolbar-title>
            </v-toolbar>
            <v-list flat>
              <!-- display: block -->
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="secondary">mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <!-- display: block -->
                  <v-list-item-title>
                    {{ $wob.client.user?.email || 'Anonymous' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-card-actions>
              <!-- show login when not authenticated -->
              <v-btn
                text
                color="secondary"
                v-if="!$wob.client.isAuthenticated"
                @click="$wob.login()"
              >
                Sign in
              </v-btn>
              <!-- show logout when authenticated -->
              <v-btn
                text
                color="secondary"
                v-if="$wob.client.isAuthenticated"
                @click="$wob.logout()"
              >
                Sign out
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </template>
    </v-app-bar>

    <v-main app>
      <v-container fluid style="height: 100%">
        <v-fade-transition mode="out-in">
          <router-view></router-view>

          <!-- 
            TODO the key forces both route update and create/mount rather than reuse of component on individual view
            can transitions be applied without this?
            <router-view :key="$route.path"></router-view> -->
        </v-fade-transition>
      </v-container>
    </v-main>

    <v-footer app class="justify-center text-body-1"
      ><v-icon small color="black">mdi-copyright </v-icon> 2019-{{
        thisYear
      }}
      Web of Buildings Scandinavia AB</v-footer
    >
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data: () => ({
    drawer: false,
    menu: [
      { icon: 'mdi-magnify', title: 'Search', to: '/search' },
      { icon: 'mdi-map-outline', title: 'Map', to: '/map' },
      { icon: 'mdi-login', title: 'Sign In', to: '/hierarchy' },
    ],
    accessToken: 'no read yet',
  }),

  computed: {
    cacheFullSize() {
      return this.$wob.size
    },
    cacheCurrentSize() {
      return this.$wob.inCache
    },
    isSynced() {
      return this.$wob.isSynced
    },
    thisYear() {
      return new Date().getFullYear()
    },
  },
  async mounted() {
    console.log('app.mounted')
    // console.log('app', Array.isArray(this.$wob.index.ids))

    const url = new URL(document.location)
    const params = new URLSearchParams(url.search)
    const focusParam = params.get('focus')
    console.log('app.created.focus.param', focusParam)
    // Parse focus param to an Iri.
    const focusWellformed = this.$wob.owl.isIri(focusParam)
    console.log('app.created.focus.wellformed', focusWellformed)
    if (focusWellformed) {
      const focus = this.$wob.owl.iri(focusParam)
      console.log('app.created.focus.iri', focus)
      // TODO temporary solution to allow the read to finalize.
      // The individual view read must trigger a read of the individual.
      setTimeout(() => {
        this.$router.push(`/individual/${encodeURIComponent(focus.value)}`)
      }, 2000)
    }
  },
}
</script>
